// extracted by mini-css-extract-plugin
export default {"title":"styles_title__h6H3N","title--with-button":"styles_title--with-button__jvVnk"};